import { useState } from "react";
import { MdGroup, MdEvent, MdExplore, MdDiversity2, MdLock } from "react-icons/md";

const NavigationTabs = ({ onTabChange, activeTab, hasSubscription = true }) => {
  const tabs = [
    { icon: <MdGroup />, label: "My Team", id: 1, requiresSubscription: true },
    { icon: <MdDiversity2 />, label: "All Teams", id: 2, requiresSubscription: false }, 
    { icon: <MdEvent />, label: "Calendar", id: 3, requiresSubscription: false },
  ];

  const handleTabClick = (tab) => {
    // If tab requires subscription and user doesn't have it, show restriction
    if (tab.requiresSubscription && !hasSubscription) {
      // The restriction will be handled by the parent component
      // We can still allow the tab change to show the restriction overlay
      onTabChange(tab.id);
    } else {
      onTabChange(tab.id);
    }
  };

  return (
    <div className="flex h-full w-full flex-col items-center overflow-x-scroll px-4 pt-[2px] lg:overflow-x-hidden lg:px-10">
      <div className="mt-[80px] md:mt-[44px] flex w-full justify-start gap-24 overflow-hidden border-b-2 border-gray-200 text-3xl dark:!border-white/10 lg:gap-[50px]">
        {tabs.map((tab) => {
          const isActive = activeTab === tab.id;
          const isLocked = tab.requiresSubscription && !hasSubscription;
          
          return (
            <div
              key={tab.id}
              className={`flex items-center gap-2 ${
                isActive
                  ? "border-b-4 border-brand-500 pb-3 hover:cursor-pointer dark:border-brand-400"
                  : "pb-[20px] hover:cursor-pointer"
              } ${
                isLocked ? "opacity-60" : ""
              }`}
              onClick={() => handleTabClick(tab)}
            >
              <p className={`text-lg ${isActive ? "text-brand-500" : "text-navy-700 dark:text-white"}`}>
                {tab.icon}
              </p>
              <p className={`text-[18px] font-medium ${isActive ? "text-brand-500" : "text-navy-700 dark:text-white"}`}>
                {tab.label}
              </p>
              {isLocked && (
                <MdLock className="text-orange-500 text-sm ml-1" size={16} />
              )}
            </div>
          );
        })}
      </div>
      
      {/* Subscription Status Indicator */}
      {!hasSubscription && (
        <div className="mt-4 p-2 bg-orange-50 dark:bg-orange-900/20 rounded-lg border border-orange-200 dark:border-orange-700">
          <p className="text-xs text-orange-700 dark:text-orange-300 text-center">
            <strong>Note:</strong> "My Team" features require a subscription. "All Teams" and "Calendar" are available for viewing.
          </p>
        </div>
      )}
    </div>
  );
};

export default NavigationTabs;
